import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { tasks as tasksApi } from 'redux/modules/api'
import { notification, modal, logError } from 'redux/modules/app'
import { combineAnd } from 'utils/apiFilter'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        ({ api, auth }) => ({
          tasksRp: api.tasks.rp,
          user: auth.user
        }),
        { ...tasksApi.rp, notification, modal, logError }
      )
    )

    class TasksRpApproval extends Component {
      static propTypes = {
        tasks: PropTypes.object,
        tasksRp: PropTypes.object.isRequired,
        decoFilterMyOnly: PropTypes.bool,
        getTasksApprovalRp: PropTypes.func.isRequired,
        getTasksSignoffRp: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        user: PropTypes.object
      }

      static defaultProps = {
        tasks: {}
      }

      componentDidMount() {
        const { tasksRp, decoFilterMyOnly } = this.props

        config.listApproval && this.handleGetTasksApprovalRp(tasksRp.approval, decoFilterMyOnly)
        config.listSignoff && this.handleGetTasksSignoffRp(tasksRp.signoff, decoFilterMyOnly)
      }

      componentWillReceiveProps(nextProps) {
        const { decoFilterMyOnly } = this.props
        const { approval, signoff } = this.props.tasksRp
        const { filter, limit, offset, sort } = nextProps.tasksRp.approval
        const {
          filter: filterSo,
          limit: limitSo,
          offset: offSetSo,
          sort: sortSo
        } = nextProps.tasksRp.signoff

        if (
          approval.filter !== filter ||
          approval.limit !== limit ||
          approval.offset !== offset ||
          approval.sort !== sort ||
          decoFilterMyOnly !== nextProps.decoFilterMyOnly
        ) {
          config.listApproval &&
            this.handleGetTasksApprovalRp(nextProps.tasksRp.approval, nextProps.decoFilterMyOnly)
        }

        if (
          signoff.filter !== filterSo ||
          signoff.limit !== limitSo ||
          signoff.offset !== offSetSo ||
          signoff.sort !== sortSo ||
          decoFilterMyOnly !== nextProps.decoFilterMyOnly
        ) {
          config.listSignoff &&
            this.handleGetTasksSignoffRp(nextProps.tasksRp.signoff, nextProps.decoFilterMyOnly)
        }
      }

      handleGetTasksApprovalRp = (tasksRp, myOnly) => {
        const filterMyOnly = myOnly || this.props.decoFilterMyOnly
        const personId = this.props.user.personId
        const combinedFilter = combineAnd(tasksRp.filter,
          filterMyOnly
            ? `residentialProject.award.awardLeader.person.id=${personId}`
            : '')

        return this.props.getTasksApprovalRp({ ...tasksRp, filter: combinedFilter })
      }

      handleGetTasksSignoffRp = (tasksRp, myOnly) => {
        const filterMyOnly = myOnly || this.props.decoFilterMyOnly
        const personId = this.props.user.personId

        const combinedFilter = combineAnd(tasksRp.filter,
          filterMyOnly
            ? `residentialProject.award.awardLeader.person.id=${personId}`
            : '')

        return this.props.getTasksSignoffRp({ ...tasksRp, filter: combinedFilter })
      }

      handleSuccess = () => {
        const { tasksRp } = this.props

        this.props.notification(
          'Residential project has been approved',
          'success'
        )
        this.props.modal(null)
        this.handleGetTasksApprovalRp(tasksRp)
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            tasks={{
              ...this.props.tasks,
              rp: this.props.tasksRp
            }}
            tasksRp={undefined}
          />
        )
      }
    }
    return enhance(TasksRpApproval)
  }
}

export default decorator
